import { INavLinkGroup } from "@fluentui/react"
import { MenuSideBar } from "../../../components/menu/menuSideBar"

export const HazardConfiguracionMenu = () => {
    const navLinkGroups: INavLinkGroup[] = [
        {
          name: "Configuraciones",
          links: [
            {
              key: "GrupoIncidente",
              name: "Incidentes",
              url: "grupoincidentes",
              icon: "EntitlementRedemption",
            },
            {
              key: "Condicion",
              name: "Condición Insegura",
              url: "condiciones",
              icon: "EntitlementRedemption",
            },
            {
              key: "Acto",
              name: "Acto Inseguro",
              url: "actos",
              icon: "EntitlementRedemption",
            },
            {
              key: "elementoEstandar",
              name: "Elementos Estándar",
              url: "elementos",
              icon: "EntitlementRedemption",
            },
            {
              key: "ubicacion",
              name: "Ubicación",
              url: "ubicaciones",
              icon: "EntitlementRedemption",
            },
          ],
        }
      ]
    return (
        <MenuSideBar links={navLinkGroups}/>
    )
}